import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#2C2C2E',
        height: 90,
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomColor: '#196059',
        borderBottomWidth: 2,
    },
    contentLeft: {
        width: 50,
        alignContent: "center",
        justifyContent: "center"
    },
    contentRight: {
        width: 50,
        alignContent: "center",
        justifyContent: "center"
    },
    contentCenter: {
        fontWeight: 'bold',
        alignContent: "center",
        justifyContent: "center"
    },
    title: {
        color: '#fff',
    },
    iconsHeader: {
        textAlign: "center"
    }
});

export default styles;
